import { FRONTEND_URL } from '@/constants/common';
import { getEntityId } from '@/utils';

/** Public viewing (property display) sign up page of the property in the client app. */
export const getViewingUrl = (propertyId?: string) => {
  const entityId = getEntityId(propertyId ?? '');

  if (!FRONTEND_URL || !entityId) return '';

  return `${FRONTEND_URL.replace(/\/+$/, '')}/registrer-deg-for-visning/${entityId}`;
};
